import { getSale } from './getSale';
import { updateSale } from './updateSale';
import { addBills } from './addBills';
import { updateBills } from './updateBills';
import { deleteBills } from './deleteBills';
import { updateFinancingData } from './updateFinancingData';
import { changeState } from './changeState';
import { reEnteredVehicle } from './reEnteredVehicle'

export const Sales = {
  getSale,
  updateSale,
  addBills,
  updateBills,
  deleteBills,
  updateFinancingData,
  changeState,
  reEnteredVehicle
}